import okiPersonal from './oki-personal/oki-personal.vue';
import okiFinancial from './oki-financial/oki-financial.vue';
import okiCardUpload from './oki-card-upload/oki-card-upload.vue';
import okiSummary from './oki-summary/oki-summary.vue';
import okiProgressBar from './oki-progress-bar/oki-progress-bar.vue';
import okiSuccess from './oki-success/oki-success.vue';
import okiTechnicalError from './oki-technical-error/oki-technical-error.vue';
import { VueAccordion, VueAccordionItem } from '@ui-common/vue-accordion';
import eventBus from '../../common/js/event-bus/event-bus';
import VueProgress from '@ui-common/vue-progress';
import VUeModal from '@ui-common/vue-modal';
import VueRouter from 'vue-router';
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';
import { OKI_PAGES, ROUTE_NAMES, SOKI_PAGES } from './constants/oki-constants';

const routes = [
	{ path: ROUTE_NAMES.SZEMELYES, component: okiPersonal },
	{ path: ROUTE_NAMES.KARTYAESSZAMLA, component: okiFinancial },
	{ path: ROUTE_NAMES.KARTYAKEP, component: okiCardUpload },
	{ path: ROUTE_NAMES.OSSZEGZES, component: okiSummary },
	{ path: ROUTE_NAMES.KOSZONJUK, component: okiSuccess },
	{ path: '*', redirect: ROUTE_NAMES.SZEMELYES }
];

const router = new VueRouter({
	routes
});

const TA_EVENTS = {
	OKI: {
		[ROUTE_NAMES.SZEMELYES]: 'OKI_SZEMELYES_ADATOK_VHK',
		[ROUTE_NAMES.KARTYAESSZAMLA]: 'OKI_KARTYA_ES_SZAMLA_ADATOK_VHK'
	},
	SOKI: {
		[ROUTE_NAMES.SZEMELYES]: 'SOKI_SZEMELYES_ADATOK_VHK',
		[ROUTE_NAMES.KARTYAESSZAMLA]: 'SOKI_KARTYA_ES_SZAMLA_ADATOK_VHK',
		[ROUTE_NAMES.KARTYAKEP]: 'SOKI_KARTYAKEP_FELTOLTES_VHK'
	}
};

export default {
	data() {
		return {};
	},
	router,
	props: {
		swImgPath: {
			required
		},
		cardId: {
			required
		}
	},
	components: {
		okiProgressBar,
		okiSuccess,
		okiTechnicalError,
		VueAccordion,
		VueAccordionItem,
		VueProgress,
		VUeModal
	},
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		phoneNumber() {
			return this.personalData ? this.personalData.mobilePhoneNumber : '';
		},
		isFirstPage() {
			return this.currentPage == ROUTE_NAMES.SZEMELYES;
		},
		notLastPage() {
			return this.currentPage != ROUTE_NAMES.OSSZEGZES;
		},
		...mapState(['currentPage', 'visitedPages', 'personalData', 'finished', 'validPages', 'technicalError', 'sessionId', 'soki', 'cardData']),
		...mapState({
			email: (state) => state.personal.personalData.email
		})
	},
	methods: {
		sendVhkTa() {
			let okiSoki = this.soki ? 'SOKI' : 'OKI';
			let data = {
				taEvent: TA_EVENTS[okiSoki][this.currentPage],
				vhkData: {
					sessionId: this.sessionId,
					step: this.getPageIndex(this.currentPage)
				}
			};
			this.postTaData({ taData: data, vhk: true });
		},
		getPageIndex(page) {
			let allPages = this.soki ? SOKI_PAGES : OKI_PAGES;
			let found = false;
			let result = 0;
			for (let i = 0; i < allPages.length && !found; ++i) {
				if (page === allPages[i].link) {
					result = i + 1;
					found = true;
				}
			}
			return result;
		},
		...mapActions(['init', 'setSoki', 'setSwImagePath', 'postTaData'])
	},
	created() {
		this.init(this.cardId).then(() => {
			const event = new CustomEvent('call-request-oki-soki-set-payload', {
				detail: this.sessionIds
			});
			window.dispatchEvent(event);
		});
		this.setSwImagePath(this.swImgPath);
		eventBus.$on('modal-opened', (modalId) => {
			if (modalId == 'oki-vhk-modal') {
				this.sendVhkTa();
			}
		});
	}
};
